import { InventoryContextForType, InventoryType } from '../../../modules/inventory/types';
import firebase from 'firebase/compat/app';
import Message, { Type } from '../../../components/Notification/Message';
import InventoryTable, { InventoryRow } from '../Table';

export async function duplicatePump(record: InventoryRow) {
  const { id, ...copy } = record;
  try {
    Message({
      key: 'addInventory',
      message: 'Loading...',
      // description: "Sensoren blev tilføjet korrekt",
      type: Type.LOADING,
    });
    await firebase
      .firestore()
      .collection('inventory')
      .add({
        ...copy,
        createTime: new Date(),
        updateTime: new Date(),
      });
    // form.resetFields();
    Message({
      key: 'addInventory',
      message: `Alt blev tilføjet korrekt`,
    });
  } catch (error) {
    console.error(error);
    Message({
      key: 'addInventory',
      type: Type.ERROR,
      message: `Der skete en fejl`,
      description: `Kunne ikke oprette Pumpe, prøv venligst igen`,
    });
  }
}

export default function TableList({
  data,
  setVisible,
}: {
  data: InventoryContextForType<InventoryType.PUMP>[];
  setVisible: (id: string) => void;
}) {
  return (
    <InventoryTable
      type={InventoryType.PUMP}
      data={data}
      setVisible={setVisible}
      onDuplicate={duplicatePump}
    />
  );
}
